import { BeakerIcon, ClipboardDocumentListIcon, PlusIcon } from '@heroicons/react/24/outline'
import { Link } from 'react-router-dom'
import { DASHBOARD_WIDGET_CLASS } from './dashboardUtils.ts'
import { OrderWizardDropTarget } from '../../OrderWizard/module.tsx'

export const CreateOrderLinksWidget = () => (
  <section className={`${DASHBOARD_WIDGET_CLASS} xl:col-span-7`}>
    <div className="mb-4 flex items-center gap-2">
      <PlusIcon className="h-5 w-5 text-slate-600" />
      <h2 className="text-lg font-semibold text-slate-900">Create order</h2>
    </div>
    <OrderWizardDropTarget>
      {(dropTarget) => (
        <div className="grid grid-cols-1 gap-3 lg:grid-cols-2">
          {dropTarget(
            <Link
              to="/createOrderLab"
              className="group rounded-lg border border-slate-200 bg-slate-50 p-4 transition-all hover:border-primary/40 hover:bg-white hover:shadow-sm"
            >
              <div className="flex items-start gap-3">
                <div className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-primary/10">
                  <BeakerIcon className="h-4 w-4 text-primary" />
                </div>
                <div className="min-w-0">
                  <div className="font-medium text-slate-900 transition-colors group-hover:text-primary">Using FASTQ raw data</div>
                  <p className="mt-1 text-sm text-slate-500">Start a lab-side order when files and primer details are already available.</p>
                </div>
              </div>
            </Link>
          )}
          <Link
            to="/createOrderCustomer"
            className="group rounded-lg border border-slate-200 bg-slate-50 p-4 transition-all hover:border-primary/40 hover:bg-white hover:shadow-sm"
          >
            <div className="flex items-start gap-3">
              <div className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-primary/10">
                <ClipboardDocumentListIcon className="h-4 w-4 text-primary" />
              </div>
              <div className="min-w-0">
                <div className="font-medium text-slate-900 transition-colors group-hover:text-primary">Prepare order for lab</div>
                <p className="mt-1 text-sm text-slate-500">
                  Create the customer-side draft when metadata is ready and sequencing still depends on a lab.
                </p>
              </div>
            </div>
          </Link>
        </div>
      )}
    </OrderWizardDropTarget>
  </section>
)
